import React from "react";
import {
	TextField,
} from "@mui/material";

import { Controller } from "react-hook-form";
import { commonErrorParameters } from "./fields";
import { withStyles } from "@mui/styles";

const ITEM_HEIGHT = 48;

interface ZPlaySelectProps extends Readonly<{ children?: React.ReactNode }>
{
	name: string,
	label: string,
	control: any,
	trigger: any,
	formState: any,
	disabled?: boolean,
	required?: boolean,
	defaultValue?: any,
	onChange?: (data: string) => string,
	noNullValue?: boolean
}

const styles = () => ({
	root: {
		"& .MuiInputBase-formControl .MuiNativeSelect-select-MuiInputBase-input-MuiFilledInput-input": {
			backgroundColor: "#FFFFFF",
		}
	}
});

class ZPlaySelect extends React.Component<ZPlaySelectProps, {}>
{
	static defaultProps = {
		disabled: false,
		required: false,
		variant: "standard",
	};

	render()
	{
		return (<Controller
				name={this.props.name}
				control={this.props.control}
				defaultValue={this.props.defaultValue || ""}
				render={({field}) => (<TextField
						{...field}
						select
						sx={{mt: 1}}
						fullWidth
						required={this.props.required}
						disabled={this.props.disabled || this.props.formState.isSubmitting}
						label={this.props.label}
						variant="filled"
						size="small"
						{...commonErrorParameters(this.props.name, this.props.formState)}
						SelectProps={{
							MenuProps: {PaperProps: {sx: {maxHeight: ITEM_HEIGHT * 4.5}}},
							native: true,
						}}
						onChange={({target: {value}}) => {
							const newValue = this.props.onChange?.(value) || value;
							field.onChange(newValue);
							this.props.trigger(this.props.name);
						}}
					>
					{!this.props.noNullValue && <option aria-label="None" value="" />}
						{this.props.children}
					</TextField>)}
			/>);
	}
}

export default withStyles(styles)(ZPlaySelect);
